import { Box, Button, Typography } from "@mui/material";
import HourglassTopRoundedIcon from "@mui/icons-material/HourglassTopRounded";

const PaymentNotYetReflected = ({ methods }) => {
  return (
    <Box
      sx={{
        minHeight: "calc(100vh)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "520px",
          border: "1px solid #E6E8F0",
          borderRadius: "16px",
          backgroundColor: "#FFFFFF",
          boxShadow: "0 14px 34px rgba(6, 10, 45, 0.08)",
          p: { xs: "28px 20px", md: "36px 28px" },
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          gap: "14px",
        }}
      >
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#FFF4E5",
            color: "#B26A00",
          }}
        >
          <HourglassTopRoundedIcon fontSize="medium" />
        </Box>

        <Typography
          sx={{
            fontFamily: "var(--font-grenettepromedium)",
            fontSize: "22px",
            lineHeight: "30px",
            color: "#060A2D",
          }}
        >
          Payment Pending Confirmation
        </Typography>

        <Typography
          sx={{
            fontSize: "14px",
            lineHeight: "24px",
            color: "#4B5563",
          }}
        >
          <span style={{ fontWeight: 600, textTransform: "capitalize" }}>
            {methods}
          </span>{" "}
          payment is not yet reflected in our system. Please wait a moment and
          reload this page.
        </Typography>

        <Button
          variant="contained"
          onClick={() => window.location.reload()}
          sx={{
            mt: "4px",
            minWidth: "180px",
            height: "44px",
            borderRadius: "10px",
            textTransform: "none",
            fontWeight: 500,
          }}
        >
          Reload
        </Button>
      </Box>
    </Box>
  );
};

export default PaymentNotYetReflected;